import { render } from "./ModelSearch.vue?vue&type=template&id=3aa08133&scoped=true"
import script from "./ModelSearch.vue?vue&type=script&lang=js"
export * from "./ModelSearch.vue?vue&type=script&lang=js"

import "./ModelSearch.vue?vue&type=style&index=0&id=3aa08133&scoped=true&lang=css"

import exportComponent from "C:\\Users\\WONHAP\\Websites\\aswo-api\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa08133"]])

export default __exports__